import React from "react";
import "../ProductCardsModems.css";
import { Link } from "react-router-dom"; 
import '../../i18n';
import { useTranslation } from 'react-i18next';

import ImageSpin21 from "../../assets/images/modems/processed/spin_21_usbl.png"

const Spin21_USBL = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <Link to="/usbl-product#spin21_usbl_spec" className="card-link-wrapper">
        <div className="card">
            <img src={ImageSpin21} alt={t('products.types.communcation_21_USBL.title')} className="card-image" />
            <div className="card-content">
              <h3 className="card-title">{t('products.types.communcation_21_USBL.title')}</h3>
              <p className="card-description">
                <ul class="features-list">
                  <li>{t('products.types.communcation_21_USBL.li_1')}</li>
                  <li>{t('products.types.communcation_21_USBL.li_2')}</li>
                  <li>{t('products.types.communcation_21_USBL.li_3')}</li>
                  <li>{t('products.types.communcation_21_USBL.li_4')}</li>
                </ul>
              </p>
            </div>
          </div>
        </Link>
  );
};
export default Spin21_USBL;